import React, { useMemo } from 'react';
import { ConfigContext } from '../context';
import { validateConfig } from '../utils';
const NEXT_PREFIX = 'NEXT_PUBLIC_';
const defaultUseHandleConfigError = ()=>{
    return undefined;
};
export const createConfig = (defaultConfig, handleConfigError)=>{
    const envConfig = Object.fromEntries(Object.keys(process.env).filter((key)=>key.startsWith(NEXT_PREFIX)).map((key)=>[
            key.replace(NEXT_PREFIX, '').split('_').map((value, index)=>{
                const lower = value.toLowerCase();
                if (index > 0) {
                    return lower.charAt(0).toUpperCase() + lower.slice(1);
                }
                return lower;
            }).join(''),
            process.env[key]
        ]));
    const config = {
        ...envConfig,
        ...defaultConfig
    };
    try {
        validateConfig(config);
    } catch (error) {
        if (handleConfigError) {
            handleConfigError(error);
        } else {
            throw error;
        }
    }
    return config;
};
const ConfigENVProvider = ({ children, defaultConfig, useHandleConfigError = defaultUseHandleConfigError })=>{
    const handleConfigError = useHandleConfigError();
    const data = useMemo(()=>createConfig(defaultConfig, handleConfigError), [
        defaultConfig,
        handleConfigError
    ]);
    return /*#__PURE__*/ React.createElement(ConfigContext.Provider, {
        value: data
    }, children);
};
export default ConfigENVProvider;
